import { Box, MantineSize, MantineStyleProps } from "@mantine/core";
import { CSSProperties, ImgHTMLAttributes, useEffect, useState } from "react";

interface SafeImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallbackSrc?: string;
  height?: number | string;
  width?: number | string;
  fit?: "contain" | "cover" | "fill" | "none" | "scale-down";
  radius?: number | string;
  style?: CSSProperties;

  // Mantine layout props
  visibleFrom?: MantineSize;
  hiddenFrom?: MantineSize;
  m?: MantineStyleProps["m"];
  p?: MantineStyleProps["p"];
  className?: string;
}
export const SafeImage = ({
  src,
  fallbackSrc = "/images/no-image.png",
  alt,
  height,
  width,
  fit = "cover",
  radius = 0,
  style,
  onClick,
  visibleFrom,
  hiddenFrom,
  m,
  p,
  className,
  ...rest
}: SafeImageProps) => {
  const [imgSrc, setImgSrc] = useState(src);

  // 🔁 Sync when src changes
  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  return (
    <Box
      visibleFrom={visibleFrom}
      hiddenFrom={hiddenFrom}
      m={m}
      p={p}
      className={className}
      style={{ width, height }}
    >
      <img
        src={imgSrc}
        alt={alt}
        onError={() => setImgSrc(fallbackSrc)}
        onClick={onClick}
        style={{
          display: "block",
          width: "100%",
          height: "100%",
          objectFit: fit,
          borderRadius: radius,
          cursor: onClick ? "pointer" : undefined,
          ...style,
        }}
        {...rest}
      />
    </Box>
  );
};
